import styled from 'styled-components';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const ColumnToggle = styled(Button)`
  ${mixin.flex({})};
  width: 16px;
  height: 16px;

  /* 박스 크기에 맞춰 벡터로 스케일 */
  svg {
    display: block;
    width: 100%;
    height: 100%;
  }

  @media ${({ theme }) => theme.media.smMax} {
    width: ${mixin.pxToVw('16')};
    height: ${mixin.pxToVw('16')};
  }
`;
